<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-menu-button></ion-menu-button>
        </ion-buttons>
        <ion-title>
            <ion-item lines="none">
                <span show-md class="tag">Bedrijf:&nbsp;</span>
                <mat-form-field>
                    <input matInput
                        [matAutocomplete]="auto"
                        [(ngModel)]="inpID"
                        #inpIDRef
                        (input)='inpIDChanged($any($event.target).value, false)'
                    >
                    <mat-autocomplete #auto="matAutocomplete"
                        panelWidth='400px'
                        (optionSelected)='inpIDChanged($event.option.value, true)'
                    >
                        <mat-option *ngFor="let lst of bedrChoices" [value]="lst.ID">
                            <span>{{lst.ID}}: {{lst.txt}}</span>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <ion-button (click)="doClearSrch()">
                    <ion-icon name="search"></ion-icon>
                </ion-button>
            </ion-item>
        </ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-row>
        <ion-col size="auto">
            <ion-button expand="block" (click)="addBedr()">
                <ion-icon name="add-circle" size="large"></ion-icon>Nieuw bedrijf
            </ion-button>
        </ion-col>
    </ion-row>

    <mat-card *ngIf="bedrData">
        <table class='taglist'>
            <tr *ngIf="bedrData.BedrNaam">
                <td></td>
                <td><span class="tag">Naam</span></td>
                <td width="100%">{{bedrData.BedrNaam}}</td>
            </tr>
            <tr *ngIf="bedrData.BedrAdres">
                <td>
                    <a target="_system" [href]=mapsUrl(bedrData.BedrAdres)>
                        <ion-button size="small"><ion-icon name="location"></ion-icon></ion-button>
                    </a>
                </td>
                <td><span class="tag">Adres</span></td>
                <td style="white-space: pre;">{{bedrData.BedrAdres}}</td>
            </tr>
            <tr *ngIf="bedrData.BedrTel">
                <td><a [href]="'tel:'+bedrData.BedrTel">
                    <ion-button size="small"><ion-icon name="call"></ion-icon></ion-button>
                </a></td>
                <td><span class="tag">Telefoon</span></td>
                <td>{{bedrData.BedrTel}}</td>
            </tr>
            <tr *ngIf="bedrData.BedrMobiel">
                <td><a [href]="'tel:'+bedrData.BedrMobielStrip">
                    <ion-button size="small"><ion-icon name="phone-portrait-sharp"></ion-icon></ion-button>
                </a></td>
                <td><span class="tag">Mobiel</span></td>
                <td>{{bedrData.BedrMobiel}}</td>
            </tr>
            <tr *ngIf="bedrData.BedrEmail">
                <td><a  *ngIf="bedrData.BedrEmail" [href]="'mailto:'+bedrData.BedrEmail">
                    <ion-button size="small"><ion-icon name="mail-open"></ion-icon></ion-button>
                </a></td>
                <td><span class="tag">Email</span></td>
                <td>{{bedrData.BedrEmail}}</td>
            </tr>
        </table>
        <ion-row>
            <ion-col size="auto">
                <ion-button expand="block" (click)="addOrdr()" *ngIf="newOrderAllowed && inpID" [disabled]="bedrFailliet">
                    <ion-icon name="add-circle" size="large"></ion-icon>Nieuwe order
                </ion-button>
            </ion-col>
        </ion-row>
        <span class="warning"> {{bedrData.Waarschuwing}}</span>
    </mat-card>

    <mat-card *ngIf="bedrData && bedrContacts">
        <table class='afstand'>
            <tr *ngFor="let bc of bedrContacts">
                <td width="30px">
                    <a  *ngIf="bc.BCdoorkiesStrip" [href]="'tel:'+bc.BCdoorkiesStrip">
                        <ion-button size="small"><ion-icon name="call"></ion-icon></ion-button>
                    </a>
                </td>
                <td width="30px">
                    <a  *ngIf="bc.BCgsmStrip" [href]="'tel:'+bc.BCgsmStrip">
                        <ion-button size="small"><ion-icon name="phone-portrait-sharp"></ion-icon></ion-button>
                    </a>
                </td>
                <td width="30px">
                    <a  *ngIf="bc.BCemail" [href]="'mailto:'+bc.BCemail">
                        <ion-button size="small"><ion-icon name="mail-open"></ion-icon></ion-button>
                    </a>
                </td>
                <td>{{bc.BCvoornaam}} {{bc.BCtussenv}} {{bc.BCnaam}}</td>
                <td>{{bc.BCfunctie}}</td>
            </tr>
        </table>
    </mat-card>
</ion-content>
